var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.832 6.49731L5.74581 13.6161L3.38605 13.9623C1.18388 14.2392 0.895503 12.9237 1.02658 12.2313L1.41983 10.1541L9.67825 2.88365M13.832 6.49731L15.5769 4.96111C15.9702 4.49951 16.4421 3.36859 15.1837 2.53772L13.6107 1.15292C13.3483 1.03752 12.5877 0.875964 11.6442 1.15292L9.67825 2.88365M13.832 6.49731L9.67825 2.88365",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/EditWhite.0a53fe4d00ff75671a3b3f6501d31bd7.svg";
export { ForwardRef as ReactComponent };